import { type AppRole } from 'connect-graphql/generated';

import { isLearner } from '@/src/roleAuthorizers';

/**
 * Generates an array of user IDs for connected user avatars based on the learner ID,
 * the latest evaluator ID, and the viewing user role.
 *
 * @param {string} learnerId
 *   The ID of the learner in scope.  This ID will be added to the array of User IDs if the viewing
 *   user is a learner.
 * @param {null | string} latestEvaluatorId
 *   The ID of the latest evaluator.  This ID will be added to the array of User IDs if it is not
 *   null.
 * @param {AppRole} viewingUserRole
 *   The role of the viewing user, which is used to determine whether or not the learner ID should
 *   be included in the array of User IDs.
 *
 * @returns {string[] | undefined} An array of user IDs if there are any, otherwise undefined.
 */
export const getUserIdsForConnectedUserAvatars = (
  learnerId: string,
  latestEvaluatorId: null | string,
  viewingUserRole: AppRole,
): string[] | undefined => {
  const userIds: string[] = [];

  if (!isLearner(viewingUserRole)) {
    userIds.push(learnerId);
  }

  if (latestEvaluatorId) {
    userIds.push(latestEvaluatorId);
  }

  return userIds.length ? userIds : undefined;
};
